import { Button } from "../components/Button/Button";
import { Container } from "../components/Container/Container";
import { PageHeader } from "../components/PageHeader/PageHeader";
import { Section } from "../components/Section/Section";

export function NotFound() {
  return (
    <>
      <PageHeader
        eyebrow="404"
        title="This page is not available."
        intro="The page may have moved, or the address may be incorrect."
      />
      <Section>
        <Container>
          <Button href="/">Return home</Button>
        </Container>
      </Section>
    </>
  );
}
